const axios = require('axios')

export const test = () => {
  const uri = `http://localhost:7001/cash/v1/balance/alert`
  return axios.get(uri)
}
